
const initialState = {
    APIResponse:{}
};

const workorderApiResponseReducer = (state = initialState, action) => {
switch (action.type) {
  case "API_RESPONSE_DATA":
    return {
      ...state,
      APIResponse : action.payload,
    };
  default:
    return state;
}
};

export default workorderApiResponseReducer;
